import { render, staticRenderFns } from "./PreviewMainArticle.vue?vue&type=template&id=e4883d5e&scoped=true&"
import script from "./PreviewMainArticle.vue?vue&type=script&lang=js&"
export * from "./PreviewMainArticle.vue?vue&type=script&lang=js&"
import style0 from "./PreviewMainArticle.vue?vue&type=style&index=0&id=e4883d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4883d5e",
  null
  
)

export default component.exports